<template>
  <div class="all">
    <!-- 區塊一 -->
    <section id="section1" class="section1">
      <div class="header">
        <div class="video-mask" :class="{played: video_status}"></div>
        <video id="Banner" ref="BannerVideo" autoplay loop muted playsinline>
          <source src="/static/video/banner.mp4" type="video/mp4">
        </video>
        <div class="parallax-wrap">
          <div id="scene">
            <div data-depth="0.2" class="layer-dot"></div>
          </div>
          <div class="layer-text">
            <div class="custom-container banner-contain">
              <div class="text-wrap">
                <h1>You Can't Do the Web Alone</h1>
                <h2>網站怎能隨便呢？</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 電腦版 -->
      <div class="service-wrap desktop">
        <div class="item-container">
          <div class="accord-wrapper">
            <div class="service-item" v-for="(item,index) in section1.serviceType">
              <router-link :to="item.href">
                <div class="service-type">
                  <div class="type_en">{{item.name_en}}</div>
                  <div class="type_ch">{{item.name_ch}}</div>
                </div>
                <div class="accord-content" :style="{'background-image': 'url(' + '/static/images/' + item.background + ')'}">
                  <div class="smoky">
                    <ul>
                      <li v-for="serviceList in item.detail">{{serviceList.list}}</li>
                    </ul>
                    <h2 class="service-name">{{item.name_ch}}</h2>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 行動裝置版 -->
      <div class="service-wrap mobile">
        <ul>
          <li><router-link :to="{name:'Service-web'}">WEB / APP 設計開發</router-link></li>
          <li><router-link :to="{name:'Service-graphic'}">DESIGN  / 平面設計</router-link></li>
          <li><router-link :to="{name:'Service-cis'}">BRAND / 品牌設計</router-link></li>
          <li><router-link :to="{name:'Photographic'}">商業攝影 / 動態影像</router-link></li>
        </ul>
      </div>
    </section>

    <!-- 區塊二 -->
    <section class="section2">
      <div class="custom-container">
        <div class="all-in-one">
          <div class="s2-title-wrap">
            <h1 class="s2-title" data-aos="fade-right" data-aos-duration="1200">{{section2.header}}</h1>
            <hr>
          </div>
          <ul class="step">
            <li data-aos="fade-up" data-aos-duration="1200" :data-aos-delay="100 + i*100" v-for="(step,i) in section2.step">
              <img class="black" :src="'/static/images/' + step.icon_b" alt="">
              <img class="white" :src="'/static/images/' + step.icon_w" alt="">
              <div class="type">{{step.text}}</div>
            </li>
          </ul>
          <div class="other-info d-flex justify-content-between" data-aos="fade-up" data-aos-duration="800"
            data-aos-delay="500">
            <div class="ad">只要NT$5999元/年</div>
            <router-link :to="{name:'Service-web'}" class="btn more-btn-1 rounded-0">了解更多</router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- 區塊三 -->
    <section class="section3">
      <div class="custom-container">
        <div class="header d-flex" data-aos="fade-up" data-aos-duration="800">
          <div class="onepage">一頁式網頁</div>
          <div class="text desktop">一頁就是全部，簡化的設計提升訪客的體驗，無需再打開其他的連結，客戶也不用擔心找不到<br>網頁或是錯過資訊。</div>
          <div class="text mobile">一頁就是全部，客戶無需再打開其他的連結，客戶也不用擔心找不到網頁或是錯過資訊。</div>
        </div>
        <div class="content d-flex">
          <div class="demo-img" data-aos="fade-right" data-aos-duration="800" data-aos-delay="300">
            <img src="/static/images/img_onepage.png" alt="onepage-demo">
          </div>
          <div class="onepage-program">
            <div class="program-contain d-flex">
              <div class="item d-flex justify-content-center align-items-center" data-aos="zoom-in" data-aos-duration="800"
                data-aos-delay="500"><span>專屬<br class="mobile-br">形象設計</span></div>
              <div class="item d-flex justify-content-center align-items-center" data-aos="zoom-in" data-aos-duration="800"
                data-aos-delay="600"><span>響應式<br class="mobile-br">網頁設計</span></div>
              <div class="item d-flex justify-content-center align-items-center" data-aos="zoom-in" data-aos-duration="800"
                data-aos-delay="700"><span>彈性資訊<br class="mobile-br">內容調整</span></div>
            </div>
            <div class="program-price" data-aos="fade-up" data-aos-duration="800" data-aos-delay="700">
              <div class="price-border">
                <div class="price-wrap">
                  <div class="offer">
                    <div class="currency">NT$</div>
                    <div class="offer-price">8,000/兩年</div>
                  </div>
                  <div class="average">NT 6,000 / 年</div>
                </div>
              </div>
            </div>
            <router-link :to="{name:'Service-web'}" class="btn more-btn-2 rounded-0" data-aos="fade-left" data-aos-duration="800" data-aos-delay="800">了解更多</router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- 區塊四 -->
    <section class="section4">
      <div class="custom-container">
        <h1 class="header" data-aos="fade-up" data-aos-duration="800">WEB 形象網頁</h1>
        <h3 class="s4-title d-none d-md-block" data-aos="fade-up" data-aos-duration="800">| 超過40項【方案內容】任您選擇</h3>
        <div class="program-wrap d-flex" data-aos="fade-up" data-aos-duration="800">
          <div class="program-item">
            <ul>
              <li>專業設計操刀 </li>
              <li> 40項以上網站功能</li>
              <li>1300萬張以上商用授權圖庫</li>
              <li>上百種風格版型變化</li>
            </ul>
          </div>
          <div class="program-item">
            <ul>
              <li>專案專人的企劃服務</li>
              <li> 國際網域贈送</li>
              <li>上架商品數量無限</li>
              <li>自訂頁面無上限</li>
            </ul>
          </div>
          <div class="program-item">
            <ul>
              <li>虛擬主機</li>
              <li> 完整後台管理</li>
              <li>Google流量分析</li>
            </ul>
          </div>
        </div>
        <h3 class="s4-title" data-aos="fade-up" data-aos-duration="800">| 領先市場的五大功能模組</h3>
        <div class="five-module d-flex" data-aos="fade-up" data-aos-duration="800">
          <div class="module-item">
            <img src="/static/images/icon_funtion.svg" alt="">
            <div class="module-type">常用功能</div>
          </div>
          <div class="module-item">
            <img src="/static/images/icon_design-2.svg" alt="">
            <div class="module-type">優質設計</div>
          </div>
          <div class="module-item">
            <img src="/static/images/icon_system.svg" alt="">
            <div class="module-type">系統功能</div>
          </div>
          <div class="module-item">
            <img src="/static/images/icon_shopping.svg" alt="">
            <div class="module-type">電子商務</div>
          </div>
          <div class="module-item">
            <img src="/static/images/icon_marketing.svg" alt="">
            <div class="module-type">行銷功能</div>
          </div>
        </div>
        <h3 class="s4-title" data-aos="fade-up" data-aos-duration="800">| 市場一年價格，我們一次給您5年</h3>
        <div class="program-select d-flex" data-aos="fade-up" data-aos-duration="800">
          <div class="three-year d-flex">
            <div class="program-select-item">
              <div class="select-years">1年方案</div>
              <div class="price">9,999</div>
            </div>
            <div class="program-select-item">
              <div class="select-years">2年方案</div>
              <div class="price">15,998</div>
              <div class="average">NT 7,999 / 年</div>
            </div>
            <div class="program-select-item">
              <div class="select-years">3年方案</div>
              <div class="price">20,997</div>
              <div class="average">NT 6,999 / 年</div>
            </div>
          </div>
          <div class="five-year">
            <div class="program-select-item">
              <div class="custom-border">
                <div class="select-years">5年方案</div>
                <div class="price">29,995</div>
                <div class="average">NT 5,999 / 年</div>
              </div>
            </div>
          </div>
        </div>
        <div class="free-maintain-wrap d-flex justify-content-between" data-aos="fade-up" data-aos-duration="800">
          <div class="free-maintain">
            <h3 class="s4-title"><span>| 專屬的貼心售後服務</span><span class="d-none d-md-inline-block"> ＝ 網站內容免費維護</span></h3>
            <p>網站上線後，享有每月三頁的免費資料上架額度，不需要聘用網站維護人員，<br class="desktop-br"> 為公司省下一個月上萬的人力成本。</p>
          </div>
          <div class="more">
            <img src="/static/images/icon_logotext-2.svg" alt="" class="img-fluid d-none d-md-block">
            <router-link :to="{name:'Service-web'}" class="btn more-btn-2 rounded-0">了解更多</router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- 區塊五 -->
    <section class="section5">
      <div class="custom-container">
        <h1 class="title">｜設計專案</h1>
        <div class="custom-row">
          <div class="custom-grid" v-for="grid in section5.project">
            <div class="project-card" data-aos="zoom-in" data-aos-duration="800">
              <div class="project-img" :style="{'background-image': 'url(' + '/static/images/' + grid.img + ')'}"></div>
              <div class="project-text">{{grid.name}}</div>
            </div>
          </div>
        </div>
        <div class="more">
          <router-link :to="{name:'Projects'}" class="btn rounded-0">了解更多</router-link>
        </div>
      </div>
    </section>
    <!-- 區塊六 -->
    <section class="section6">
      <div class="custom-container">
        <div class="slogan-wrap d-flex align-items-center justify-content-center">
          <div class="braces">{</div>
          <div class="text desktop">
            <h5>不同網站需求，我們都能滿足</h5>
            <h6>超過四十項的網站標準功能，通通不用加錢</h6>
          </div>
          <div class="text mobile">
            <h5>不同網站需求 都能滿足</h5>
            <h6>超過四十項的網站標準功能</h6>
          </div>
          <div class="braces">}</div>
        </div>
        <!-- Desktop -->
        <div class="variety desktop">
          <div class="type-wrap d-flex">
            <div class="website-type" data-aos="fade-in" data-aos-duration="800">
              <h3>
                形象官網
                <div class="border-l"></div>
                <div class="border-t"></div>
                <div class="border-r"></div>
              </h3>
              <ul>
                <li>專業主視覺設計</li>
                <li>多元版型選擇</li>
                <li>每月免費維護</li>
                <li>完善權限管理</li>
                <li>十多種標準功能</li>
                <li>無限頁面數量</li>
              </ul>
            </div>
            <div class="website-type" data-aos="fade-in" data-aos-duration="800" data-aos-delay="300">
              <h3>
                B2B網站
                <div class="border-l"></div>
                <div class="border-t"></div>
                <div class="border-r"></div>
              </h3>
              <ul>
                <li>使用者經驗分析(UX)</li>
                <li>使用者介面設計(UI)</li>
                <li>SPA最新網站架設技術</li>
                <li>CSS客製化系統服務</li>
                <li>程式開發及撰寫</li>
                <li>資料庫規劃及建置</li>
                <li>虛擬空間代管服務</li>
              </ul>
            </div>
            <div class="website-type" data-aos="fade-in" data-aos-duration="800" data-aos-delay="600">
              <h3>
                電商網站
                <div class="border-l"></div>
                <div class="border-t"></div>
                <div class="border-r"></div>
              </h3>
              <ul>
                <li>專屬形象設計</li>
                <li>無限商品上架</li>
                <li>多樣化行銷功能</li>
                <li>第三方系統串接</li>
                <li>0%交易手續費</li>
              </ul>
            </div>
            <div class="website-type" data-aos="fade-in" data-aos-duration="800" data-aos-delay="900">
              <h3>
                一頁式網頁
                <div class="border-l"></div>
                <div class="border-t"></div>
                <div class="border-r"></div>
              </h3>
              <ul>
                <li>專屬形象設計</li>
                <li>響應式網頁設計</li>
                <li>4+1專屬資訊內容</li>
                <li>網路空間節省</li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Tablet -->
        <div class="variety tablet">
          <div class="type-contain d-inline-flex">
            <div class="type-wrap">
              <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <a class="nav-link website-type active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home"
                  role="tab" aria-controls="v-pills-home" aria-selected="true">形象官網</a>
                <a class="nav-link website-type" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile"
                  role="tab" aria-controls="v-pills-profile" aria-selected="false">客製化網站</a>
                <a class="nav-link website-type" id="v-pills-messages-tab" data-toggle="pill" href="#v-pills-messages"
                  role="tab" aria-controls="v-pills-messages" aria-selected="false">電商網站</a>
                <a class="nav-link website-type" id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings"
                  role="tab" aria-controls="v-pills-settings" aria-selected="false">一頁式網站</a>
              </div>
            </div>
            <div class="type-detail">
              <div class="tab-content" id="v-pills-tabContent">
                <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                  <ul>
                    <li>專業主視覺設計</li>
                    <li>多元版型選擇</li>
                    <li>每月免費維護</li>
                    <li>完善權限管理</li>
                    <li>十多種標準功能</li>
                    <li>無限頁面數量</li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                  <ul>
                    <li>使用者經驗分析(UX)</li>
                    <li>使用者介面設計(UI)</li>
                    <li>SPA最新網站架設技術</li>
                    <li>CSS客製化系統服務</li>
                    <li>程式開發及撰寫</li>
                    <li>資料庫規劃及建置</li>
                    <li>虛擬空間代管服務</li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                  <ul>
                    <li>專屬形象設計</li>
                    <li>無限商品上架</li>
                    <li>多樣化行銷功能</li>
                    <li>第三方系統串接</li>
                    <li>0%交易手續費</li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                  <ul class="custom-ul">
                    <li>專屬形象設計</li>
                    <li>響應式網頁設計</li>
                    <li>4+1專屬資訊內容</li>
                    <li>網路空間節省</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Mobile -->
        <div class="variety mobile">
          <div class="type-wrap d-flex align-items-center">
            <div class="website-type">形象官網</div>
            <div class="website-type">客製化網站</div>
            <div class="website-type">電商網站</div>
            <div class="website-type">一頁式網站</div>
          </div>
        </div>
        <div class="function-fee" data-aos="fade-up" data-aos-duration="800">
          <h4 class="title">常用付費加值功能</h4>
          <div class="content-wrap d-flex">
            <div class="content">產品條件搜索、升級RWD網站、會員限定系統、商品上架、多國語言版本、客化表單、商品庫存、會員系統、VIP會員、詢價車、購物車、金流串接、額外產品上架服務、客製化頁面排版、手機版</div>
            <router-link :to="{name:'Service-web'}" class="btn more-btn-2 rounded-0">了解更多</router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- 區塊七 -->
    <section class="section7">
      <div class="custom-container" data-aos="fade-right" data-aos-duration="800">
        <div class="s7-title">
          <h3>升級RWD網站</h3>
          <h4>你的網站有隨解析度自行調整大小了嗎？</h4>
        </div>
        <ul class="advantage">
          <li>
            <img src="/static/images/icon_RWD1.svg" alt="">
            <span>提升網站排名</span>
          </li>
          <li>
            <img src="/static/images/icon_RWD2.svg" alt="">
            <span>新增訪客數量</span>
          </li>
          <li>
            <img src="/static/images/icon_RWD3.svg" alt="">
            <span>支援各平台裝置</span>
          </li>
        </ul>
      </div>
    </section>
    <!-- 區塊八 -->
    <section class="section8">
      <div class="custom-container">
        <div class="addSSL-wrap d-flex align-items-center justify-content-center" data-aos="fade-up" data-aos-duration="800">
          <div class="braces">{</div>
          <div class="text">
            <h5>加裝SSL憑證</h5>
            <h6>同等產品，我們堅持市場最低價</h6>
          </div>
          <div class="braces">}</div>
        </div>
        <div class="SSL-advantage d-flex">
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="300">
            <img src="/static/images/icon_SSL1.svg" alt="">
            <div class="text">全程加密傳輸訊息</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="600">
            <img src="/static/images/icon_SSL2.svg" alt="">
            <div class="text">標章顯示網站安全性</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="900">
            <img src="/static/images/icon_SSL3.svg" alt="">
            <div class="text">增加網頁曝光機會</div>
          </div>
        </div>
      </div>
    </section>
    <!-- 區塊九 -->
    <section class="section9">
      <div class="custom-container">
        <div class="title" data-aos="fade-up" data-aos-duration="800">
          <img src="/static/images/text_form.svg" alt="">
          <h6>請留下您的聯絡方式 我們將會有專人與您聯繫</h6>
        </div>
        <div class="form-wrap" data-aos="fade-in" data-aos-duration="800" data-aos-delay="300">
          <infiniteForm v-bind:Success_modal="Success_modal" v-on:callSuccess="showSuccess"></infiniteForm>
        </div>
      </div>
    </section>

    <submitSuccess v-if="Success_modal" v-bind:closemodal="close_modal" v-on:endSubmit="hideSuccess"></submitSuccess>
  </div>
</template>

<script>
  import navigation from './navigation.vue';
  import infiniteForm from './infiniteForm.vue';
  import submitSuccess from './submitSuccess.vue';
  import Parallax from 'parallax-js'
  export default {
    name: 'Home',
    components: {
      navigation,
      infiniteForm,
      submitSuccess
    },
    data() {
      return {
        video_status:false,
        Success_modal: false,
        close_modal: true,
        section1: {
          serviceType: [{
              name_ch: '設計開發',
              name_en: 'WEB / APP',
              href: '/service/web',
              background: 'service-bg01.jpg',
              detail: [{
                  list: 'WEB / APP 客製化設計'
                },
                {
                  list: 'UX / UI 使用者介面分析設計設計'
                },
                {
                  list: 'RWD 響應式網頁'
                },
                {
                  list: 'SPA 最新網站架設技術'
                },
                {
                  list: 'CSS 客製化系統服務'
                }
              ]
            },
            {
              name_ch: '平面設計',
              name_en: 'DESIGN',
              href: '/service/graphic',
              background: 'service-bg02.jpg',
              detail: [{
                  list: '平面設計'
                },
                {
                  list: '活動視覺設計'
                },
                {
                  list: '產品包裝設計'
                },
                {
                  list: '書冊設計'
                }
              ]
            },
            {
              name_ch: '品牌設計',
              name_en: 'BRAND',
              href: '/service/cis',
              background: 'service-bg03.jpg',
              detail: [{
                  list: 'CIS企業識別系統設計'
                },
                {
                  list: '品牌識別規範'
                },
                {
                  list: '輔助圖形設計'
                },
                {
                  list: '品牌策略/品牌形象顧問'
                },
              ]
            },
            {
              name_ch: '攝影影像',
              name_en: 'CP / MOTION',
              href: '/photographic',
              background: 'service-bg04.jpg',
              detail: [{
                  list: '商業攝影'
                },
                {
                  list: '形象廣告影片製作'
                },
                {
                  list: '紀錄片微電影'
                },
                {
                  list: '2D / 3D 動畫影片'
                }
              ]
            }
          ]
        },
        section2: {
          header: '讓人目眩神迷的一次到位',
          step: [{
              icon_b: 'icon_plan.svg',
              icon_w: 'icon_plan_white.svg',
              text: '規劃'
            },
            {
              icon_b: 'icon_design.svg',
              icon_w: 'icon_design_white.svg',
              text: '設計'
            },
            {
              icon_b: 'icon_pc.svg',
              icon_w: 'icon_pc_white.svg',
              text: '主機'
            },
            {
              icon_b: 'icon_backeng.svg',
              icon_w: 'icon_backeng_white.svg',
              text: '後台'
            },
          ]
        },
        section5: {
          project: [{
              name: 'WEB_2018_08 東林工程行',
              img: 'project01.jpg',
            },
            {
              name: '',
              img: 'project02.jpg',
            },
            {
              name: '',
              img: 'project03.jpg',
            },
            {
              name: '',
              img: 'project04.jpg',
            },
          ]
        }
      }
    },
    methods: {
      close(){

      },
      showSuccess() {
        this.Success_modal = true;
      },
      hideSuccess() {
        this.Success_modal = false;
      },
    },
    mounted() {
      var video = this.$refs.BannerVideo;
      if(video.played){
        this.video_status = true;
      }else{
        this.video_status = false;
      }
      var scene = document.getElementById('scene');
      var parallaxInstance = new Parallax(scene,{
        invertX: false,
        invertY: false,
        limitX:false,
        limitY:false, 
        scalarX:20,
        scalarY:20
      });
      $(".service-item").on({
        mouseenter: function () {
          var self = $(this);
          $(".service-item").not(self).addClass('widthlow');
          self.addClass('widthmax');
          $(".widthmax").addClass('opacity');
        },
        mouseleave: function () {
          var self = $(this);
          $(".service-item").not(self).removeClass('widthlow');
          self.removeClass('widthmax');
          self.removeClass('opacity');
        }
      });
    },
    watch:{
      // video_status(){
      //   var video_mask = document.querySelector(".video-mask")
      //   if(this.video_status == true){
      //     alert('Hi');
      //     setTimeout(() => {
      //       video_mask.style.display = "none";
      //       alert('Fuck Timeout');
      //     }, 3000);
      //   }
      // }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import 'src/assets/scss/common.scss';
  @import 'src/assets/scss/home/section1.scss';
  @import 'src/assets/scss/home/section2.scss';
  @import 'src/assets/scss/home/section3.scss';
  @import 'src/assets/scss/home/section4.scss';
  @import 'src/assets/scss/home/section5.scss';
  @import 'src/assets/scss/home/section6.scss';
  @import 'src/assets/scss/home/section7.scss';
  @import 'src/assets/scss/home/section8.scss';
  @import 'src/assets/scss/home/section9.scss';

</style>



// WEBPACK FOOTER //
// src/components/Home.vue